import type { ReactNode } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Flex, Stack, Text } from "@similarweb/ui-components/foundations";

import { ALL_TAB_SHOW_LESS, ALL_TAB_SHOW_MORE } from "app/components/React/SearchAutocompleteWithTabs/texts";
import { translate } from "app/filters/i18nFilter";

import { AllTabSectionToggleButton } from "./AllTabPanelPrimitives";

const { carbon } = colorsPalettes;

type AllTabCollapsibleSectionProps = {
    title: string;
    /** When false, the section title row is omitted (e.g. Reports tab search — tab already shows context). */
    showHeading?: boolean;
    isToggleable: boolean;
    isExpanded: boolean;
    onToggleExpanded: () => void;
    toggleDataAutomation: string;
    children: ReactNode;
    dataAutomation?: string;
};

export const AllTabCollapsibleSection = ({
    title,
    showHeading = true,
    isToggleable,
    isExpanded,
    onToggleExpanded,
    toggleDataAutomation,
    children,
    dataAutomation,
}: AllTabCollapsibleSectionProps) => {
    const showHeaderRow = showHeading || isToggleable;

    return (
        <Stack
            gap="8px"
            paddingX="16px"
            paddingY="12px"
            width="100%"
            data-automation={dataAutomation ? dataAutomation : `tab-all-section-${title}`}
        >
            {showHeaderRow ? (
                <Flex
                    justifyContent={showHeading ? "space-between" : "flex-end"}
                    alignItems="center"
                    paddingX="4px"
                    width="100%"
                >
                    {showHeading ? (
                        <Text
                            fontVariant="captionTitle"
                            color={carbon[400]}
                        >
                            {title}
                        </Text>
                    ) : null}

                    {isToggleable ? (
                        <AllTabSectionToggleButton
                            type="button"
                            data-automation={toggleDataAutomation}
                            onClick={onToggleExpanded}
                        >
                            {translate(isExpanded ? ALL_TAB_SHOW_LESS : ALL_TAB_SHOW_MORE)}
                        </AllTabSectionToggleButton>
                    ) : null}
                </Flex>
            ) : null}

            <Stack gap="8px">{children}</Stack>
        </Stack>
    );
};
